/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { Outlet } from 'react-router-dom';
import { useServerErrorVar } from '../utils/apollo-vars';
import { AppProviders } from '../providers';
import { Wrapper } from '../styled';
import { LayoutWithAsideMenu } from '../layouts';
import { PrivateRoute } from './PrivateRoute';
import { ServerIsDownModal } from './modals';

const AppAndAdminRoutesWrapper = () => {
  const serverError = useServerErrorVar();

  return (
    <PrivateRoute>
      <AppProviders>
        <LayoutWithAsideMenu>
          {!serverError ? (
            <Wrapper>
              <Outlet />
            </Wrapper>
          ) : (
            <ServerIsDownModal />
          )}
        </LayoutWithAsideMenu>
      </AppProviders>
    </PrivateRoute>
  );
};

export { AppAndAdminRoutesWrapper };
